import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import LanternImg from "../assets/PlaceHolder/night.jpg"
import Footer from "../components/Footer"
import Card from "../components/Card"
import PopularServices from "../components/PopularServices";
import ServicesMenu from "../components/ServicesMenu";
import thumb from "../assets/thumb/tiko-giorgadze-_RhLAHDzy1I-unsplash.jpg";


function Service (){
    return(
        <>
        <Navbar/>
        <Hero 
        cName="hero-mid" 
        heroImg={thumb} 
        title="SERVICES"
        btnClass="hide"/>
        <ServicesMenu/>
        
        <Footer/>
        
        </>
    );
}

export default Service;